import React from "react";
import { Skeleton } from "@mui/material";
import Grid from '@mui/material/Grid2';
import Container from "@mui/material/Container";

const OrgDashSkeleton = ({md = 8}) => {

    return (
        <>
                <Grid container spacing={2} justifyContent="center" style={{marginTop:100,marginBottom:50}}>
                    <Grid item size={{xs:12,md:md}}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={450}
                            animation="wave"
                            style={{borderRadius:16,marginBottom:10}}
                        />
                    </Grid>
                </Grid>
        </>


    );
};

export default OrgDashSkeleton;
